import { MutationTree } from "vuex";
import { RootState, RootMutations } from "@/store/interfaces/root";
import { MutationTypes } from "./mutation-types";

export const mutations: MutationTree<RootState> & RootMutations = {
  [MutationTypes.SET_LOADING_STATUS](state, payload) {
    state.loading = payload;
  },
  [MutationTypes.SET_CSRF_INFORMATION](state, payload) {
    state.csrf = payload;
  },
  [MutationTypes.SET_BANNER_STATUS](state, payload) {
    state.banner = payload;
  },
  [MutationTypes.SET_DIALOG_STATUS](state, payload) {
    state.dialog = payload;
  },
  [MutationTypes.SET_NOTIFICATION_STATUS](state, payload) {
    state.notification = payload;
  },
  [MutationTypes.SET_ALERT_STATUS](state, payload) {
    state.alert = payload;
  }
};
